import { Trackable } from '@/components/common';
import { cn } from '@/lib';
import React from 'react';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({
  currentPage,
  totalPages,
  onPageChange,
}: PaginationProps): React.ReactNode {
  return (
    <div className='mt-0 flex h-[1rem] items-center justify-center'>
      {Array.from({ length: totalPages }).map((_, index) => (
        <Trackable key={`HERO_SLIDER_ITEM_${index}`} eventName='Click' eventScope='Pagination' eventProps={{
          "Slide Index": index,
          "Section": 'Hero Carousel',
        }}>
          <button
            aria-label={`pagination_` + index}
            onClick={() => onPageChange(index)}
            className='touch-manipulation p-2 outline-none select-none [-webkit-tap-highlight-color:transparent] focus:outline-none'
          >
            <div
              className={cn(
                `rounded-2xl`,
                currentPage === index
                  ? 'bg-primary size-3'
                  : 'size-2.5 bg-black',
              )}
            ></div>
          </button>
        </Trackable>
      ))}
    </div>
  );
}
